module.exports = __webpack_public_path__ + "media/fonts/Roboto-Black-1224b64c95f897e542d9bfdd3861b0ed.ttf";